export function removeErrors() {
  const errorMessage = document.querySelectorAll(".error-message");
  if (errorMessage.length > 0) {
    errorMessage.forEach((el) => {
      el.remove();
    });
  }
}
